module.exports = __webpack_public_path__ + "img/pride-1.5145b8e8.png";